import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';

function DatePickerField({
  name,
  label,
  value,
  onChange,
  inputRef,
  error,
  placeholder,
  sx,
  ...props
}) {
  return (
    <DatePicker
      value={value ?? null}
      onChange={(newValue) => {
        console.log('DatePicker changed value:', newValue);
        onChange(newValue);
      }}
      sx={{ ...sx }}
      PopperProps={{
        placement: 'bottom-start' // ✅ helps consistent positioning
      }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={(ref) => {
            // 🔥 CRITICAL FIX: merge refs so popper anchors correctly
            if (params.inputRef) {
              params.inputRef(ref);
            }
            if (inputRef) {
              inputRef(ref);
            }
          }}
          id={name}
          label={label}
          margin="dense"
          size="small"
          fullWidth
          placeholder={placeholder}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}

function GreatDatePicker({ name, label, control, error, placeholder, sx, ...props }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePickerField
            {...field}
            name={name}
            label={label}
            error={error}
            placeholder={placeholder}
            sx={sx}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
}

export default GreatDatePicker;
